import { TextCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { ClientSaldoEntryInfoCellTemplate } from "../customcells/ClientSaldoEntryInfoCellTemplate";

class ClientSaldoEntryInfoCellTypeHandler implements ICellTypeHandler {
  cellType = "clientsaldoentryinfo";
  isCustom = true;
  instance = new ClientSaldoEntryInfoCellTemplate();
  determineNewValue = (change: any) => (change.newCell as TextCell).text;
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    },
  ) => {
    const [
      {
        clientBalances,
        infoClearanceDialog,
        infoSettledPaymentsMetadataMap,
        selectedClientSaldoEntryPaymentId,
      },
      { setClientBalancePageStoreValues, populatePaymentsByClientSaldoEntry },
    ] = context["clientBalancePageStore"];
    const { t } = context;

    const paymentId = entry["paymentId"];
    const showButton =
      entry["isBankStatementEntryClearancePayment"] === true &&
      (entry["premiumAmount"] ?? 0) < 0;

    const parentBalance = clientBalances?.find(
      (cb: any) => cb.clientBalanceId === infoClearanceDialog?.clientBalanceId,
    );
    const clientId = parentBalance?.clientId ?? entry["clientId"];
    const companyNumber =
      parentBalance?.companyNumber ?? entry["companyNumber"];

    const highlighted = rowsMetadataMap[paymentId]?.highlighted ?? false;

    return {
      type: "clientsaldoentryinfo",
      paymentId,
      showButton,
      highlighted,
      infoFn: () => {
        if (clientId == null || companyNumber == null) return;

        const isToggleOff = selectedClientSaldoEntryPaymentId === paymentId;

        const nextMap: Record<string, any> = {};
        Object.keys(infoSettledPaymentsMetadataMap).forEach((k) => {
          nextMap[k] = {
            ...infoSettledPaymentsMetadataMap[k],
            highlighted: !isToggleOff && String(paymentId) === String(k),
          };
        });

        if (isToggleOff) {
          setClientBalancePageStoreValues({
            selectedClientSaldoEntryPaymentId: null,
            infoSettledPaymentsMetadataMap: nextMap,
            paymentsByClientSaldoEntry: [],
            paymentsByClientSaldoEntryMetadataMap: {},
            paymentsByClientSaldoEntryStatus: "none",
            paymentsByClientSaldoEntrySort: null,
          });
          return;
        }

        setClientBalancePageStoreValues({
          selectedClientSaldoEntryPaymentId: paymentId,
          infoSettledPaymentsMetadataMap: nextMap,
          paymentsByClientSaldoEntrySort: null,
        });
        populatePaymentsByClientSaldoEntry({
          clientId,
          companyNumber,
          paymentIdClientSaldoEntry: paymentId,
        });
      },
      t,
    };
  };
}

export default ClientSaldoEntryInfoCellTypeHandler;
